import React from "react";

interface FacilityNameBubbleProps {
  facilityName: string;
}

const FacilityNameBubble: React.FC<FacilityNameBubbleProps> = ({ facilityName }) => {
  return (
    <div className="relative flex flex-col items-center animate-bounce-slow">
      {/* 施設名は省略しない。英語の長い名前が細長く縦に伸びて部屋を覆わないよう、横幅を広めに取る */}
      <div className="px-4 py-2 rounded-[16px] border-2 border-[#B80001] bg-[#B80001] text-lg font-bold font-sans shadow-sm text-white max-w-[24rem] text-center break-words">
        {facilityName}
      </div>
      <div className="w-0 h-0 border-x-8 border-x-transparent border-t-8 border-t-[#B80001]" />
      <div className="w-0 h-0 -mt-2 border-x-7 border-x-transparent border-t-7 border-t-[#B80001]" />
    </div>
  );
};

export default FacilityNameBubble;
